import { useEnhancedQuery } from "@uplift-ltd/apollo";
import { setUser } from "@uplift-ltd/sentry";
import React, { useEffect } from "react";
import { UserContext } from "./context";
export function UserContextProvider(_a) {
    var children = _a.children, currentUserQuery = _a.currentUserQuery, _b = _a.skip, skip = _b === void 0 ? false : _b;
    var _c = useEnhancedQuery(currentUserQuery, {
        skip: skip,
    }, {
        auth: false,
    }), loading = _c.loading, error = _c.error, data = _c.data, refetch = _c.refetch, refetching = _c.refetching;
    var isAuthenticated = data ? data.isAuthenticated : false;
    var currentUser = data ? data.currentUser : null;
    useEffect(function () {
        if (currentUser) {
            setUser({
                id: currentUser.id,
                email: currentUser.email,
            });
        }
    }, [currentUser]);
    return (React.createElement(UserContext.Provider, { value: { loading: loading, error: error, isAuthenticated: isAuthenticated, currentUser: currentUser, refetch: refetch, refetching: refetching } }, children));
}
